import clsx from 'clsx'

type CitationBadgeProps = {
  label: string
  /** Renders the badge as its own external link. Omit when the badge sits inside another anchor. */
  href?: string
  /** Handler used instead of navigating: the url is signed at click time. */
  onActivate?: () => void
  title?: string
  /** 'brand' = tenant-tinted pill (clickable sources), 'neutral' = gray pill (non-clickable references). */
  variant?: 'brand' | 'neutral'
  size?: 'sm' | 'md'
  className?: string
}

const SIZE_CLASSES = {
  sm: 'text-[10px] min-w-3.5 h-3.5',
  md: 'text-[10px] min-w-4 h-4',
}

export const CitationBadge = ({
  label,
  href,
  onActivate,
  title,
  variant = 'brand',
  size = 'md',
  className,
}: CitationBadgeProps) => {
  const classes = clsx(
    'inline-flex items-center justify-center font-bold rounded-full shrink-0',
    SIZE_CLASSES[size],
    variant === 'brand'
      ? 'citation-pill transition-colors'
      : 'border border-border bg-background text-muted-foreground',
    className,
  )

  if (href) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        title={title}
        onClick={
          onActivate &&
          ((event) => {
            event.preventDefault()
            onActivate()
          })
        }
        className={clsx(classes, 'cursor-pointer no-underline')}
      >
        {label}
      </a>
    )
  }

  return (
    <span title={title} className={classes}>
      {label}
    </span>
  )
}
